export enum SortTypeEnum {
    Price = 'price',
    Rating = 'rating',
    Discount = 'discount',
    DistanceFromCenter = 'distanceFromCenter',
    DistanceFromBeach = 'distanceFromBeach',
}

export enum SortApiMapping {
    PriceAsc = 'priceAsc',
    PriceDesc = 'priceDesc',
    RatingDesc = 'ratingDesc',
    DiscountDesc = 'discountDesc',
    DistanceFromCenterAsc = 'distanceFromCenterAsc',
    DistanceFromBeachAsc = 'distanceFromBeachAsc',
}
